import { ICON_NAMES } from '@/components/icons/constants'

export const globalVariablesMixin = {
  data () {
    return {
      ICON_NAMES
    }
  }
}
